
import { defineComponent, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            createdAt: null as string | null,
            id: null as number | null,
        })

        const reset = () => {
            state.createdAt = null
            state.id = null

            emit('reset')
        }

        const search = () => {
            emit('search', {
                id: state.id,
                createdAt: state.createdAt,
            })
        }

        return {
            state,
            reset,
            search,
        }
    },
})
